import { createPlateEditor } from 'platejs/react'
import type {
  AnyPlatePlugin,
  CreatePlateEditorOptions,
  PlateCorePlugin,
} from 'platejs/react'

import { createContentGenerationPlugin } from '~publish/legacy/ai/plugins/content-generation'

import type {
  BufferEditor,
  BufferValue,
} from '../../../legacy/editor/BufferEditor/types.plate'
import { createEmojiSearchPlugin } from '../../../legacy/editor/plugins/emoji'
import { createGenerateContentPlugin } from '../../../legacy/editor/plugins/generate-content'
import { createLinkPlugin } from '../../../legacy/editor/plugins/link'
import { SimpleLinkElementUI } from '../../../legacy/editor/plugins/link/ui/SimpleLinkElementUI'
import { createTextSanitizationPlugin } from '../../../legacy/editor/plugins/text-sanitization'

export const IDEA_EDITOR_ID = 'idea-editor'

export const createIdeaEditor = (
  options: CreatePlateEditorOptions<BufferValue> = {},
): BufferEditor => {
  // Each plugin factory returns a distinctly-parameterized PlatePlugin, so a
  // precisely-typed array doesn't type-check — collect loosely and narrow
  // with a type guard rather than a cast (the guard also drops test-mocked
  // undefineds).
  const list: unknown[] = [
    createTextSanitizationPlugin(),
    createEmojiSearchPlugin({ options: { maxSuggestions: 8 } }),
    createLinkPlugin({ component: SimpleLinkElementUI }),
    createGenerateContentPlugin(),
    createContentGenerationPlugin(),
  ]
  return createPlateEditor<BufferValue>({
    id: IDEA_EDITOR_ID,
    plugins: list.filter((plugin): plugin is AnyPlatePlugin =>
      Boolean(plugin),
    ) as PlateCorePlugin[],
    nodeId: false,
    ...options,
  }) as unknown as BufferEditor
}
